import React, { Component } from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import '../../../../../chat.css';

const styles = () => ({
    cardmedia: {
        height: 140,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    image: {
        height: 140,
        width: 'inherit'
    },
    title: {
        fontSize: '1rem'
    },
    cardContenttxt: {
        paddingBottom: 0,
    },
    cardContent: {
        paddingBottom: 0,

    }
});

/**
 * A message type that shows a card.
 */
class CardMessage extends Component {
    render() {
        const { classes } = this.props;
        return(
            <Card className={'card-message-container'}>
                <CardContent className={classes.cardContent}>
                    <CardMedia
                        className={classes.cardmedia}
                        title={this.props.title}
                    >
                        <img style={{maxHeight:'140px', width:'inherit' }} src={this.props.imageUrl} alt={'image'}/>
                    </CardMedia>
                    <CardContent className={classes.cardContenttxt}>
                        <Typography className={classes.title} gutterBottom variant="h5" component="h2">
                            {this.props.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p">
                            {this.props.subtitle}
                        </Typography>
                    </CardContent>
                    <div/>
                </CardContent>
                <CardActions>
                    <Button size="small" color="primary" href={this.props.linkUrl} target={'_blank'}>
                        {this.props.linkButtonTitle}
                    </Button>
                </CardActions>
            </Card>
        );
    }
}

export default withStyles(styles)(CardMessage);
